import { render, staticRenderFns } from "./SendBroadcast.vue?vue&type=template&id=05fb6217&scoped=true&"
import script from "./SendBroadcast.vue?vue&type=script&lang=js&"
export * from "./SendBroadcast.vue?vue&type=script&lang=js&"
import style1 from "./SendBroadcast.vue?vue&type=style&index=1&id=05fb6217&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fb6217",
  null
  
)

export default component.exports